/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { APP_BASE_HREF } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { CoreModule } from './@core/core.module';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { ThemeModule } from './@theme/theme.module';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ApiService } from './providers/Api';
import { CacheService } from './providers/Cache';

import { IdRendererComponent } from './components/renderers/idRenderer.component';
import { LinkRendererComponent } from './components/renderers/linkRenderer.component';
import { StatsRendererComponent } from './components/renderers/statsRenderer.component';
import { DateRendererComponent } from './components/renderers/dateRenderer.component';
import { DescRendererComponent } from './components/renderers/descRenderer.component';
import { AddressRendererComponent } from './components/renderers/addressRenderer.component';

const CellRenderComponents = [
    IdRendererComponent,
    LinkRendererComponent,
    StatsRendererComponent,
    DateRendererComponent,
    DescRendererComponent,
    AddressRendererComponent,
];

import { NbAuthModule, NbPasswordAuthStrategy } from '@nebular/auth';


@NgModule({
  declarations: [
      AppComponent,
      ...CellRenderComponents,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    AppRoutingModule,

    NgbModule.forRoot(),
    ThemeModule.forRoot(),
    CoreModule.forRoot(),
    NbAuthModule.forRoot({
         strategies: [
           NbPasswordAuthStrategy.setup({
               name: 'email',
               baseEndpoint: 'https://api.soulsface.com/admin',
               token: {
                   key: 'token',
               },
               login: {
                   endpoint: '/login',
                   method: 'post',
               },
               logout: {
                   endpoint: '/logout',
                   method: 'get',
               },
           }),
         ],
         forms: {},
       }),
  ],
  entryComponents: [
      ...CellRenderComponents,
  ],
  bootstrap: [AppComponent],
  providers: [
    { provide: APP_BASE_HREF, useValue: '/' },
    ApiService,
    CacheService,
  ],
})
export class AppModule {
}
